function isSomeAvailable(arr, val) {
  return arr.some((arrVal) => val === arrVal);
}

export default isSomeAvailable;
